import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Component from 'flarum/common/Component';
import extract from 'flarum/common/utils/extract';
import classList from 'flarum/common/utils/classList';
import emoji from '../util/emoji';
export default class ReactionComponent extends Component {
  view() {
    const attrs = _objectSpread({}, this.attrs);
    const reaction = extract(attrs, 'reaction');
    const className = extract(attrs, 'className');
    if (!reaction) return m("span", null);
    const display = reaction.display() || reaction.identifier();
    if (!attrs.title) attrs.title = display;
    if (reaction.type() === 'emoji') {
      const _emoji = emoji(reaction.identifier()),
        url = _emoji.url;
      return m("img", Object.assign({
        className: classList(className, 'emoji'),
        src: url,
        loading: "lazy",
        draggable: "false",
        alt: display
      }, attrs));
    } else {
      return m("i", Object.assign({
        className: classList(className, reaction.identifier(), 'icon'),
        "aria-hidden": true
      }, attrs));
    }
  }
}
flarum.reg.add('fof-reactions', 'common/components/ReactionComponent', ReactionComponent);